import { ParentSettlementDetails } from 'components/templates/settlement/ParentSettlementDetails/ParentSettlementDetails';

export const ParentSettlementPage = () => <ParentSettlementDetails />;
